export const lookDataToRequestBody = (data) => ({
    query_id: data.queryId || "",
    name: data.name,
    folder_path: data.folderPath,
    root: data.root
});
export const DEFAULT_LOOK_FIELDS = [
    "id",
    "title",
    "created_at",
    "updated_at",
    "description",
    "view_count",
    "query",
    "user_external_id"
];
//# sourceMappingURL=look.js.map